import React from "react";

export function PageHeader({ title, subtitle, children, testId }) {
  return (
    <div data-testid={testId} className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
      <div>
        <h1 className="font-display text-2xl font-bold tracking-tight text-[#0B1F33]">{title}</h1>
        {subtitle && <p className="mt-0.5 text-sm text-slate-500">{subtitle}</p>}
      </div>
      {children && <div className="flex flex-wrap items-center gap-2">{children}</div>}
    </div>
  );
}

export function Card({ children, className = "", testId }) {
  return (
    <div data-testid={testId} className={`rounded-xl border border-slate-200 bg-white shadow-sm ${className}`}>
      {children}
    </div>
  );
}

export function SectionTitle({ children }) {
  return <h3 className="font-display text-base font-semibold text-[#0B1F33]">{children}</h3>;
}

export function DemoTag() {
  return <span className="rounded bg-amber-100 px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wide text-amber-700">Demo</span>;
}

export function Empty({ label = "No records found" }) {
  return <div className="py-12 text-center text-sm text-slate-400">{label}</div>;
}
